<template>
    <div style="text-align: center;">
        <ui-modal ref="addedModal" title="Vehicle Added" class="added-modal" @hide="$emit('hide')" dismiss-on="close-button esc">
            <div style="padding: 2rem 0; text-align: center;">
                <animated-check :loaded="loaded"></animated-check>
                <h2 style="margin: 2rem 0; font-size: 1.8rem;">{{ loaded ? 'Vehicle Added' : 'Adding Vehicle' }}</h2>
 
                <div v-if="loaded">
                    <span class="registration" style="margin-bottom: .5rem;" v-if="identity.registration.length > 0">{{ identity.registration }}</span>
                    <p style="margin-bottom: 2rem;">{{ identity.manufacturer.name }} {{ identity.model.name }} {{ identity.derivative }}</p>
                    <ui-button v-show="!showButtons" @click="close()">Continue</ui-button> 
                    <ui-button v-show="showButtons" @click="gotoVehicle">Go to Vehicle</ui-button> 
                    <ui-button v-show="showButtons" @click="printReceipt" v-if="instance && instance.purchase_cost">Print Purchase Receipt</ui-button> 
                    <ui-button v-show="showButtons" v-if="showAddAnother" @click="addAnother">Add Another</ui-button>
                </div>
            </div>
        </ui-modal>
    </div>
</template>

<script>
    import AnimatedCheck from '../../elements/AnimatedCheck'
    import { mapState } from 'vuex'

    export default {
        components: { AnimatedCheck },
        props: {
            loaded: {
                type: Boolean,
                default() {
                    return false;
                }
            },
            showButtons: {
                type: Boolean,
                default() {
                    return true;
                }
            },
            showAddAnother: {
                type: Boolean,
                default() {
                    return true;
                }
            }
        },
        data() {
            return {
                instance: null,
            }
        },
        computed: {
            ...mapState({ 'identity': state => state.identity.current }),
        },
        methods: {
            open() {
                this.$refs['addedModal'].open();
            },
            close() {
                this.$refs['addedModal'].close();
            },
            setInstance(instance) {
                this.instance = instance;
            },
            addAnother() {
                this.$refs['addedModal'].close();

                this.$emit('add-another');
            },
            printReceipt() {
                this.$refs['addedModal'].close();

                window.location = this.$root.buildUrl('vehicles/%s/overview/#receipt', [this.instance.id])
            },
            gotoVehicle() {
                this.$refs['addedModal'].close();

                window.location = this.$root.buildUrl('vehicles/%s/overview', [this.instance.id])
            }
        }
    }
</script>